module.exports = __webpack_public_path__ + "static/media/team-michael-fallone.603e07a8.jpg";